import { useFlowReveal } from "@/hooks/useFlowReveal";

const AboutSection = () => {
  const flowRef = useFlowReveal<HTMLDivElement>();

  return (
  <section id="about" className="section-padding section-alt" aria-labelledby="about-heading">
    <div className="max-w-7xl mx-auto">
      <p className="eyebrow mb-4">About Us</p>
      <h2 id="about-heading" className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
        About AccessBharat — Digital Accessibility Platform
      </h2>
      <p className="text-muted-foreground max-w-3xl mb-10 text-base leading-relaxed">
        AccessBharat is a trusted accessibility consultant India enterprises rely on for enterprise accessibility solutions. From web accessibility audits to accessibility monitoring software and accessibility compliance software — we deliver end-to-end website accessibility services.
      </p>

      <div ref={flowRef} className="grid gap-6 md:grid-cols-2 md:gap-8">
        {/* Mission */}
        <article className="flow-step border-t-2 border-foreground pt-5" style={{ "--i": 0 } as React.CSSProperties}>
          <h3 className="font-display text-lg font-bold text-foreground mb-3">Our Mission</h3>
          <p className="text-base text-muted-foreground leading-relaxed">
            To make digital platforms accessible to all, while helping organizations seamlessly meet global standards and Indian regulatory requirements.
          </p>
        </article>

        {/* Vision */}
        <article className="flow-step border-t-2 border-foreground pt-5" style={{ "--i": 1 } as React.CSSProperties}>
          <h3 className="font-display text-lg font-bold text-foreground mb-3">Our Vision</h3>
          <p className="text-base text-muted-foreground leading-relaxed">
            To be a trusted accessibility and compliance partner, driving inclusion at scale and setting benchmarks in regulatory-ready digital accessibility.
          </p>
        </article>

        {/* Leadership */}
        <article className="flow-step card-surface flex flex-col items-start gap-5 p-6 sm:flex-row sm:items-center md:col-span-2 md:p-8" style={{ "--i": 2 } as React.CSSProperties}>
          <div className="w-16 h-16 shrink-0 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-2xl font-display font-extrabold" aria-hidden="true">
            P
          </div>
          <div>
            <h3 className="font-display text-xl font-bold text-foreground">Priya Moily</h3>
            <p className="text-base text-muted-foreground">Founder &amp; Lead Auditor</p>
            <p className="mt-2 text-base leading-relaxed text-foreground">
              <abbr title="International Association of Accessibility Professionals">IAAP</abbr> Certified Professional in Accessibility Core Competencies (<abbr title="Certified Professional in Accessibility Core Competencies">CPACC</abbr>).
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>
  );
};

export default AboutSection;
